import { useTranslation } from "react-i18next";

interface SwitchTableButtonProps {
  text: string;
  setter?: (str: string) => void;
  id?: number;
  idSetter?: (id: number) => void;
  clientName?: string;
  clientNameSetter?: (clientName: string) => void;
  setCurrentPage?: (currentPage: number) => void;
  setTabElements?: (tabElements: string) => void;
  isCompleted?: boolean;
  setIsCompleted?: (isCompleted: boolean) => void;
}

// Usage
export function SwitchTableButton({
  text,
  setter,
  id,
  idSetter,
  clientName,
  clientNameSetter,
  setCurrentPage,
  isCompleted,
  setIsCompleted,
}: SwitchTableButtonProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (setCurrentPage) {
          setCurrentPage(1)
        }
        if (setter) {
          setter(text);
        }
        if (id !== 0 && idSetter && id) {
          idSetter(id);
        }
        if (clientName && typeof clientNameSetter === "function") {
          clientNameSetter(clientName);
        }
        if (typeof isCompleted === "boolean" && setIsCompleted) {
          setIsCompleted(isCompleted);
        }
      }}
      className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-full bg-dca-blue px-3 py-1.5 font-Nunito text-xs font-semibold whitespace-nowrap text-white shadow-sm transition-colors hover:bg-indigo-700 focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:ring-offset-2 focus-visible:outline-none"
    >
      {t(text)}
      <svg
        aria-hidden="true"
        className="size-3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.4}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5-5 5M6 12h12" />
      </svg>
    </button>
  );
}
